import _ from 'lodash';
import utils from '@bigcommerce/stencil-utils';
import StencilDropDown from './stencil-dropdown';
import urlUtils from '../common/utils/url-utils';

function obundleCategorySearch(searchQuery, searchCat, callback) {
    const headers = {
        'stencil-options': JSON.stringify({ render_with: 'search/quick-results' }),
    };

    const url = searchCat === 'all' || !searchCat
        ? `/search.php?search_query=${encodeURIComponent(searchQuery)}`
        : `/search.php?search_query=${encodeURIComponent(searchQuery)}&category%5B%5D=${encodeURIComponent(searchCat)}`;

    fetch(
        url,
        { headers },
    )
        .then(response => response.text())
        .then(text => {
            callback(null, text);
        })
        .catch(error => callback(error, null));
}

export default function () {
    const TOP_STYLING = 'top: 49px;';
    const $quickSearchForms = $('[data-quick-search-form]');
    const $quickSearchExpand = $('#quick-search-expand');
    const $searchQuery = $quickSearchForms.find('[data-search-quick]');
    const $navOverlay = $('.ob-pageOverlay');
    const stencilDropDownExtendables = {
        hide: () => {
            $quickSearchExpand.attr('aria-expanded', false);
        },
        show: (event) => {
            $quickSearchExpand.attr('aria-expanded', true);
            $searchQuery.trigger('focus');
            event.stopPropagation();
        },
    };
    const stencilDropDown = new StencilDropDown(stencilDropDownExtendables);
    stencilDropDown.bind($('[data-search="quickSearch"]'), $('#quickSearch'), TOP_STYLING);

    stencilDropDownExtendables.onBodyClick = (e, $container) => {
        // If the target element has this data tag or one of it's parents, do not close the search results
        // We have to specify `.modal-background` because of limitations around Foundation Reveal not allowing
        // any modification to the background element.
        if ($(e.target).closest('[data-prevent-quick-search-close], .modal-background').length === 0) {
            stencilDropDown.hide($container);
            $('.quickSearchResults .productGrid').empty();
            $('.quickSearchResults').hide();
            $navOverlay.hide();
            $('body').removeClass('no-scroll');
        }
    };

    // stagger searching for 300ms after last input
    const debounceWaitTime = 300;
    const doSearch = _.debounce((searchQuery, currentTarget) => {
        const searchCat = $('.ob-search-category').val();
        obundleCategorySearch(searchQuery, searchCat, (err, response) => {
            if (err) {
                return false;
            }

            const $quickSearchResults = $(currentTarget).closest('[data-quick-search-form]').siblings('.quickSearchResults');

            const windowWidth = window.innerWidth;

            $quickSearchResults.css('width', windowWidth);

            $quickSearchResults.html(response);
            $quickSearchResults.show();
            $('body').addClass('no-scroll');
            const $quickSearchResultsCurrent = $quickSearchResults.filter(':visible');
            $navOverlay.show();
            const $noResultsMessage = $quickSearchResultsCurrent.find('.quickSearchMessage');

            $quickSearchResults.on('click touch', '.modal-close', (e) => {
                e.preventDefault();
                $quickSearchResults.html('');
                $quickSearchResults.hide();
                $('body').removeClass('no-scroll');
                $navOverlay.hide();
            });

            if ($noResultsMessage.length) {
                $noResultsMessage.attr({
                    role: 'status',
                    'aria-live': 'polite',
                });
            } else {
                const $quickSearchAriaMessage = $quickSearchResultsCurrent.next();
                $quickSearchAriaMessage.addClass('u-hidden');

                const predefinedText = $quickSearchAriaMessage.data('search-aria-message-predefined-text');
                const itemsFoundCount = $quickSearchResultsCurrent.find('.product').length;

                $quickSearchAriaMessage.text(`${itemsFoundCount} ${predefinedText} ${searchQuery}`);

                setTimeout(() => {
                    $quickSearchAriaMessage.removeClass('u-hidden');
                }, 100);
            }
        });
    }, debounceWaitTime);

    utils.hooks.on('search-quick', (event, currentTarget) => {
        if (/Mobi/i.test(navigator.userAgent)) {
            return event.stopPropagation();
        }

        const searchQuery = $(currentTarget).val();

        // server will only perform search with at least 3 characters
        if (searchQuery.length < 3) {
            return;
        }

        doSearch(searchQuery, currentTarget);
    });

    // Catch the submission of the quick-search forms
    $quickSearchForms.on('submit', event => {
        event.preventDefault();

        const $target = $(event.currentTarget);
        const searchQuery = $target.find('input').val();
        const searchUrl = $target.data('url');
        const searchCat = $('.ob-search-category').val();
        let fullUrl = '';

        if (searchQuery.length === 0) {
            return;
        }

        if (searchCat !== 'all' && searchCat) {
            fullUrl = `${searchUrl}?search_query=${encodeURIComponent(searchQuery)}&category%5B%5D=${encodeURIComponent(searchCat)}`;
        } else {
            fullUrl = `${searchUrl}?search_query=${encodeURIComponent(searchQuery)}`;
        }

        urlUtils.goToUrl(fullUrl);
        window.location.reload();
    });
}
